module.exports = __webpack_public_path__ + "img/Unidad16-1.b3d786b3.png";